import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import RouteModal from "../../../Component/BasicComponents/Modal/RouteModal";
import RouteDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { Btn } from "../../../AbstractElements";
import { useGetOrgUnitsData } from "../../FSM/Beats_Patches/hooks/useBeat";
import {
  useAddSubscriberTypes,
  useOutletTypesData,
} from "../../FSM/Subscriber/hooks/useSubscriber";
import {
  useAddOnboardRequried,
  useOnboardingStatusData,
} from "../hooks/useOnBoard";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
import { showToast } from "../../../utils/toastUtils";

type ProductCardProps = {
  setIsModalOpen?: any;
  isModalOpen?: any;
  toggleModal?: any;
  title?: any;
  checkAddEditStatus?: any;
  setCheckAddEditStatus?: any;
  rowData?: any;
};
const OnboardingFormAddAndEditModal: React.FC<ProductCardProps> = ({
  rowData,
  setIsModalOpen,
  isModalOpen,
  title,
  checkAddEditStatus,
  setCheckAddEditStatus,
}) => {
  console.log(
    "🚀 ~ OnboardingFormModal.tsx:36 ~ OnboardingFormAddAndEditModal ~ rowData:",
    rowData
  );

  const [modalValues, setModalValues] = useState<any>({
    OrgUnitId: null,
    OutletTypeId: null,
    StatusTypeId: null,
    RequiredFields: [] as { id: string; name: string }[],
    startDate: "",
    endDate: "",
  });
  const [statusTypeData, setStatusTypeData] = useState([]);
  const [requriedFieldsData, setRequriedFieldsData] = useState([]);
  const [buttonDisable, setButtonDisable] = useState(false);

  const { data: orgUnitsData } = useGetOrgUnitsData({ enable: true });
  const { data: outletTypeData } = useOutletTypesData({ enable: true });
  const { data: onboardStatusData } = useOnboardingStatusData({ enable: true });
  const { mutate } = useAddOnboardRequried();

  const handleClose = () => {
    setIsModalOpen(false);
    setCheckAddEditStatus("");
    setModalValues((prevState: any) => ({
      ...prevState,
      OutletTypeId: null,
      OrgUnitId: null,
      StatusTypeId: null,
      RequiredFields: [],
      startDate: "",
      endDate: "",
    }));
    setButtonDisable(false);
  };

  const handleInputChange = (
    name: any,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = e.target;

    // Convert specific fields to numbers
    const numericFields = ["attachment", "leavePoints"];
    const updatedValue = numericFields.includes(name)
      ? value.replace(/[^0-9]/g, "")
      : value;

    setModalValues((prevState: any) => ({
      ...prevState,
      [name]: numericFields.includes(name)
        ? updatedValue === ""
          ? ""
          : Number(updatedValue)
        : updatedValue,
    }));
  };

  useEffect(() => {
    if (onboardStatusData) {
      let status_type: any;
      let requried_fields: any;
      status_type = Object.keys(
        onboardStatusData?.data?.OnBoardingStatus
      )?.reduce((arr: any, item) => {
        arr.push({
          id: item,
          label: onboardStatusData?.data?.OnBoardingStatus[item],
        });
        return arr;
      }, []);
      if (status_type && status_type?.length > 0) {
        setStatusTypeData(status_type);
      }
      requried_fields = Object.values(
        onboardStatusData?.data?.RequiredFields
      )?.reduce((arr: any, item) => {
        arr.push({ id: item, label: `${item}` });
        return arr;
      }, []);

      if (requried_fields && requried_fields?.length > 0) {
        setRequriedFieldsData(requried_fields);
      }

      // alert(checkAddEditStatus)
      if (checkAddEditStatus === "Edit") {
        let formatedRquriedField: any = [];
        if (rowData?.RequiredFields && rowData?.RequiredFields?.length) {
          formatedRquriedField = rowData?.RequiredFields?.reduce(
            (arr: any, item: any) => {
              arr?.push({ id: `${item}`, label: `${item}` });
              return arr;
            },
            []
          );
        }
        // console.log("rowDataaaa - ", rowData);
        setModalValues((prevState: any) => ({
          ...prevState,
          OutletTypeId: rowData?.OutletType?.OutlettypeId,
          OrgUnitId: rowData?.OrgUnit?.Orgunitid,
          StatusTypeId: rowData?.StatusTypeId,
          RequiredFields: formatedRquriedField || [],
          startDate: rowData?.StartDate,
          endDate: rowData?.EndDate,
        }));
      }
    }
  }, [onboardStatusData, rowData, checkAddEditStatus]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // if (modalValues?.OutletTypeId?.length <= 0) {
    //     toast.warn("Please select outlet type.");
    //     return;
    // }

    setButtonDisable(true);
    if (!modalValues?.OrgUnitId) {
      setButtonDisable(false);
      showToast.warning("Please Select the Org Unit!");
      return;
    } else if (!modalValues?.OutletTypeId) {
      setButtonDisable(false);
      showToast.warning("Please Select the Outlet Type!");
      return;
    } else if (!modalValues?.StatusTypeId) {
      setButtonDisable(false);
      showToast.warning("Please Select the Status Type!");
      return;
    } else if (!modalValues?.RequiredFields?.length) {
      setButtonDisable(false);
      showToast.warning("Please Select the Required Fields!");
      return;
    } else if (!modalValues?.startDate) {
      setButtonDisable(false);
      showToast.warning("Please  Fill the Start Date!");
      return;
    } else if (!modalValues?.endDate) {
      setButtonDisable(false);
      showToast.warning("Please Fill the End Date!");
      return;
    }
    // ✅ Compare Required Fields (sorted stringified arrays)
    const currentReqFields = modalValues?.RequiredFields?.map((f: any) =>
      String(f.id)
    ).sort();

    const initialReqFields = (rowData?.RequiredFields || [])
      .map((f: any) => String(f))
      .sort();

    const isSameRequiredFields =
      JSON.stringify(currentReqFields) === JSON.stringify(initialReqFields);

    let isSubmitted =
      modalValues?.OrgUnitId === rowData?.OrgUnitId &&
      modalValues?.OutletTypeId === rowData?.OutletTypeId &&
      modalValues?.StatusTypeId === rowData?.StatusTypeId &&
      modalValues?.startDate === rowData?.StartDate &&
      modalValues?.endDate === rowData?.EndDate &&
      isSameRequiredFields;

    if (isSubmitted) {
      setButtonDisable(false);
      return showToast.warning("No changes detected to update.");
    }
    let body: any = {
      OrgUnitId: modalValues?.OrgUnitId,
      OutletTypeId: modalValues?.OutletTypeId,
      StatusTypeId: modalValues?.StatusTypeId,
      RequiredFields: modalValues?.RequiredFields?.map((itm: any) =>
        String(itm?.id)
      ),
      StartDate: modalValues?.startDate,
      EndDate: modalValues?.endDate,
    };

    if (checkAddEditStatus === "Add") {
      mutate(body, {
        onSuccess: () => {
          handleClose();
        },
        onError: () => {
          console.log("Error in Onboarding Form !");
          setButtonDisable(false);
        },
      });
    } else {
      body["id"] = rowData?.OnBoardRequiredFieldsId;
      mutate(body, {
        onSuccess: () => {
          handleClose();
        },
        onError: () => {
          console.log("Error in Onboarding Form !");
          setButtonDisable(false);
        },
      });
    }
  };

  const handleRequriedField = (selectedValues: string[] | string[]) => {
    let selectedData = selectedValues.map((id) =>
      requriedFieldsData?.find((unit: any) => unit.id === id)
    );
    setModalValues((prevState: any) => ({
      ...prevState,
      RequiredFields: selectedData?.filter(String),
    }));
  };

  return (
    <RouteModal
      isOpen={isModalOpen}
      toggle={() => {
        setIsModalOpen(!isModalOpen);
        setModalValues((prevState: any) => ({
          ...prevState,
          OutletTypeId: null,
          OrgUnitId: null,
          StatusTypeId: null,
          RequiredFields: [],
          startDate: "",
          endDate: "",
        }));
      }}
      title={title}
      // title="Add MTP"
      size="md"
      content={
        <form onSubmit={handleSubmit}>
          <div className="row mb-0">
            <RouteDropdown
              isMulti={false}
              options={orgUnitsData?.data || []}
              asterisk={true}
              value={modalValues.OrgUnitId}
              onChange={(value: any) => {
                setModalValues((prevState: any) => ({
                  ...prevState,
                  OrgUnitId: value,
                }));
              }}
              DropdownHeading="Org Unit"
            />

            <div style={{ height: 10 }} />
            <RouteDropdown
              // isMulti={true}
              options={outletTypeData?.data || []}
              asterisk={true}
              value={modalValues.OutletTypeId}
              onChange={(value: any) => {
                setModalValues((prevState: any) => ({
                  ...prevState,
                  OutletTypeId: value,
                }));
              }}
              DropdownHeading="Outlet Type"
            />
            <div style={{ height: 10 }} />
            <RouteDropdown
              // isMulti={true}
              options={statusTypeData || []}
              asterisk={true}
              value={modalValues.StatusTypeId}
              onChange={(value: any) => {
                setModalValues((prevState: any) => ({
                  ...prevState,
                  StatusTypeId: value,
                }));
              }}
              DropdownHeading="Status Type"
            />
            <div style={{ height: 10 }} />
            <RouteDropdown
              isMulti={true}
              options={requriedFieldsData || []}
              asterisk={true}
              value={modalValues.RequiredFields.map((val: any) =>
                val.id.toString()
              )}
              onChange={(value: any) => {
                handleRequriedField(value);
              }}
              DropdownHeading="Required Field"
            />
            <div style={{ height: 15 }} />
            <CustomInput
              label="Start Date"
              placeholder="Enter Start Date"
              asterisk={true}
              type="date"
              name="startDate"
              value={modalValues.startDate}
              onChange={(e) => handleInputChange("startDate", e)}
            />
            <div style={{ height: 15 }} />
            <CustomInput
              label="End Date"
              placeholder="Enter End Date"
              asterisk={true}
              type="date"
              name="endDate"
              value={modalValues.endDate}
              onChange={(e) => handleInputChange("endDate", e)}
            />
            <div className="d-flex justify-content-start gap-2">
              <Btn
                style={{ backgroundColor: "#43B9B2", color: "white" }}
                type="submit"
                disabled={buttonDisable}
              >
                {checkAddEditStatus === "Add"
                  ? buttonDisable === false
                    ? "Submit"
                    : "Submitting..."
                  : buttonDisable === false
                  ? "Update"
                  : "Updating..."}
              </Btn>
              <Btn
                style={{
                  backgroundColor: "#F9FAFC",
                  color: "#000",
                  border: "1px solid #E0E0E0",
                }}
                type="button"
                onClick={() => {
                  setIsModalOpen(false);
                  setCheckAddEditStatus("");
                  setModalValues((prevState: any) => ({
                    ...prevState,
                    OutletTypeId: null,
                    OrgUnitId: null,
                    StatusTypeId: null,
                    RequiredFields: [],
                    startDate: "",
                    endDate: "",
                  }));
                }}
              >
                Cancel
              </Btn>
            </div>
          </div>
        </form>
      }
    />
  );
};

export default OnboardingFormAddAndEditModal;
